import React from "react";
import {useFormState} from "../../hooks/useFormState";
import Button from "../../ui/button";
import Input from "../../ui/input";
import classes from "../account/AssignModal.module.css";
import {useTranslation} from "react-i18next";
import {CustomParameter} from "../../schema";
import {useConfirmModal} from "../../hooks/useConfirmModal";

type ContentProps = React.ComponentProps<"div"> & {
  parameter: CustomParameter;
  onSave?: (data: {name: string;}) => void;
  onDelete?: () => void;
  onClose?: () => void;
};

function CustomParameterEditModalHeader() {
  const {t} = useTranslation();
  return <span>{t("components.CustomParameterEditModal.title", "Редактирование параметра")}</span>;
}

function CustomParameterEditModalContent({parameter, onSave, onDelete, onClose}: ContentProps) {
  const {t} = useTranslation();

  const formState = useFormState<{name: string;}>({
    initialValues: {
      name: parameter.name ?? "",
    },
    preventDefault: true,
    onSubmit: (data) => {
      onSave && onSave(data);
    },
  });

  const {open: openDeleteConfirm} = useConfirmModal({
    title: t("components.CustomParameterEditModal.titleDelete"),
    message: t("components.CustomParameterEditModal.messageDelete"),
    confirmText: t("common.delete", "Удалить"),
    cancelText: t("common.cancel", "Отмена"),
    onConfirm: () => {
      onDelete && onDelete();
    },
  });

  const handleDeleteClick = () => {
    if (onClose) {
      onClose();
    }
    openDeleteConfirm();
  };

  return (
    <form className={classes.root} method="post" onSubmit={formState.submitHandler}>
      <div style={{marginBottom: "16px"}}>
        <label style={{display: "block", marginBottom: "4px", fontWeight: 600}}>
          {t("components.CustomParameterEditModal.name", "Название")}
        </label>
        <Input
          name="name"
          value={formState.values.name}
          onChange={formState.changeHandler}
          required
          style={{width: "100%"}}
        />
      </div>

      <div className={classes.bottom}>
        {onDelete && (
          <Button type="button" color="danger" onClick={handleDeleteClick}>
            {t("common.delete", "Удалить")}
          </Button>
        )}
        <Button type="submit" color="success">
          {t("common.save")}
        </Button>
      </div>
    </form>
  );
}

const CustomParameterEditModal = {
  Header: CustomParameterEditModalHeader,
  Content: CustomParameterEditModalContent,
};

export default CustomParameterEditModal;
